import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import Button from '../elements-buttons/Button';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import StickyNavigation from '../shared-components/partials-navigation/StickyNavigation';

const ButtonNavigation = ({
  dispatch,
  spaceId,
  prevPage,
  submitCtaText = <FormattedMessage id="hosting.button_navigation.button_text_save_and_continue" defaultMessage="Save and Continue"/>,
  disabled = false,
  navPage = 'production'
}) => {
  const flex = classnames('flex col-xs-12 space-between', {
    'space-between': prevPage,
    end: !prevPage
  });

  return (
    <StickyNavigation className="flex middle ps-container-lg-margin ps-container-fixed">
      <div className="ps-row flex middle w-100">
        <div className={flex}>
          {prevPage && (
            <Button
              category="default"
              type="button"
              className="margin-md-right"
              onClick={() => dispatch(push(`/hosting/${navPage}/${spaceId}/${prevPage}`))
              }
            >
              <FormattedMessage
                id="hosting.button_navigation.button_text_back"
                defaultMessage="Back"
              />
            </Button>
          )}
          <Button
            category="primary"
            className="submit-cta block-xs-left"
            disabled={disabled}
            attributes={{
              'data-testing-id': 'setup-cta'
            }}
          >
            {submitCtaText}
          </Button>
        </div>
      </div>
    </StickyNavigation>
  );
};

ButtonNavigation.propTypes = {
  dispatch: PropTypes.func,
  spaceId: PropTypes.string,
  navPage: PropTypes.string,
  disabled: PropTypes.bool,
  prevPage: PropTypes.string,
  submitCtaText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ])
};

export default ButtonNavigation;
